enum EFormOption {
    JustCurious = 'JustCurious',
    TooLong = 'TooLong',
    PersonalDetails = 'PersonalDetails',
    BusinessLoanOrAlternative = 'BusinessLoanOrAlternative',
    WorriedSpam = 'WorriedSpam',
    DrivingLicence = 'DrivingLicence',
    Other = 'Other'
}
enum EVersions {
    a = 'a',
    b = 'b'
}
interface ILeavingCookie {
    started: boolean, 
    viewed: boolean,
    submitted: boolean
}
interface ISurveyObject {
    version: EVersions
    hasClickedSubmit: boolean,
    modal: HTMLElement | null,
    setVersion: Function,
    getTprGuid: Function,
    getLeavingModalCookie: Function, 
    setLeavingModalCookie: Function, 
    getCookie: Function, 
    validateForm: Function, 
    handleChange: Function, 
    submitForm: Function, 
    postForm: Function
}
interface IFormOption 
{
    value: EFormOption, 
    label: string,
}

const survey: ISurveyObject = {
    version: (Math.round(Math.random() * 10 + 1) % 2) ? EVersions.a : EVersions.b,
    hasClickedSubmit: false,
    modal: document.getElementById('survey-modal'),
    setVersion: (): void => {
        const vEls = survey.modal?.querySelectorAll('.tb-survey-form-version');
        if (!vEls) return;
        for (let i = 0; i != vEls.length; ++i){
            const v: EVersions = ((vEls[i].getAttribute('data-version') || '') as EVersions);
            if (v != survey.version){
                vEls[i].innerHTML = '';
                vEls[i].setAttribute('style','display:none');
            }
        }
    },
    getTprGuid: (): string => {
        return survey.getCookie('tprguid') || '';
    },
    getLeavingModalCookie: (): ILeavingCookie => {
        const cook: string = survey.getCookie('leavingmodal');
        const defaultCook: ILeavingCookie = {
            started: false, 
            viewed: false,
            submitted: false
        };
        try {
            return cook ? JSON.parse(cook) : defaultCook;
        }
        catch(e){
            console.log(e);
            return defaultCook;
        }
    },
    setLeavingModalCookie: (started: boolean, viewed: boolean, submitted: boolean): void => {
        const cook: string = survey.getCookie('leavingmodal');
        try {
            const arr: ILeavingCookie = cook ? JSON.parse(cook) : {
                started: started || true, 
                viewed: viewed || false,
                submitted: submitted || false
            };
            if (typeof started == 'boolean'){
                arr.started = started;
            }
            if (typeof viewed == 'boolean'){
                arr.viewed = viewed;
            }
            if (typeof submitted == 'boolean'){
                arr.submitted = submitted;
            }
            const dateexp = new Date();
            dateexp.setFullYear(dateexp.getFullYear()+1);
            const expires = "expires="+ dateexp.toString();
            const cookieData = ";" + expires + ';path=/';
            // if (location.host.indexOf('localhost') == -1){
            // 	cookieData += ";domain=." + location.host
            // }
            document.cookie = `leavingmodal=${JSON.stringify(arr)}` + cookieData;
        }
        catch(e){
          console.log(e)
        }
    }, 
    getCookie: (sName: string): string => {  
        var oCrumbles = document.cookie.split(';');
        for(var i=0; i<oCrumbles.length;i++)
        {
            var oPair= oCrumbles[i].split('=');
            var sKey = decodeURIComponent(oPair[0].trim());
            var sValue = oPair.length>1 ? oPair[1] : '';
            if(sKey == sName) {
                return decodeURIComponent(sValue);
            }
        }
        return '';
    }, 
    validateForm: (form: HTMLFormElement): boolean => {
        const formData = new FormData(form);
        const otherVal = formData.get('other');
        const vals = formData.getAll('reasons');
        const isError = !vals.length || (vals.length == 1 && vals[0] == EFormOption.Other && !otherVal);
        const errorMessage = form.querySelector('.tb-survey-error');
        const errorServerMessage = form.querySelector('.tb-survey-server-error');

        errorServerMessage && errorServerMessage.setAttribute('aria-hidden', 'true');
        errorMessage && errorMessage.setAttribute('aria-hidden', (!isError).toString().toLowerCase());
        return !isError;
    }, 
    handleChange: (form: HTMLFormElement): void => {
        if (survey.hasClickedSubmit){
            survey.hasClickedSubmit = false;
            survey.validateForm(form);
        }
    }, 
    submitForm: async (surveyForm: HTMLFormElement): Promise<void> => {
        const cancelBtn = surveyForm.querySelector('.tb-survey-buttons .button-small-caps');
        const submitBtn = surveyForm.querySelector('.tb-survey-buttons button[type=submit]');

        cancelBtn?.setAttribute('disabled', '');
        submitBtn?.setAttribute('disabled', '');
        submitBtn?.classList.add('is-loading');

        const isSuccess = await survey.postForm(surveyForm);
    
        cancelBtn?.removeAttribute('disabled');
        submitBtn?.removeAttribute('disabled');
        submitBtn?.classList.remove('is-loading');

        if (isSuccess){
            document.body.setAttribute('data-modal-open', 'false');
            survey.modal?.setAttribute('aria-hidden', 'true');
        }
        else {
            const errorServerMessage = surveyForm.querySelector('.tb-survey-server-error');
            errorServerMessage && errorServerMessage.setAttribute('aria-hidden', 'false');
        }
    }, 
    postForm: async (form: HTMLFormElement): Promise<boolean> => {
		const baseUrl = 'https://tpr-survey.azurewebsites.net/tprsurvey/v1/';
        const url = survey.version == EVersions.b ? `${baseUrl}SurveyVersionB` : `${baseUrl}SurveyVersionA`;
        const dataLayer = (window as any).dataLayer || [];
        const dealerId = parseInt(survey.modal?.dataset.dealerid || '');
        const dealerName = survey.modal?.dataset.dealername || '';
        const enquirySource = survey.modal?.dataset.enquirysource || '';
        const formData = new FormData(form);
        const otherVal = formData.get('other');
        const vals: Array<FormDataEntryValue> = formData.getAll('reasons');
        // const urlSearchParams = new URLSearchParams(window.location.search);
        // const enquirySource = urlSearchParams.get('enquiry_source') || urlSearchParams.get('utm_source');
        const sharedData = {
            'ResponseDate': (new Date()).toISOString(),
            'DealerID': dealerId, 
            'DealerName': dealerName, 
            'Other': vals.includes('Other') ? otherVal : '', 
            "Source": enquirySource
        };
        const dataAB = survey.version == EVersions.b ? {
            'TooLong': vals.includes('TooLong'), 
            'QuoteInPerson': vals.includes('QuoteInPerson'), 
            'NoBalloons': vals.includes('NoBalloons'), 
            'DontKnowFinance': vals.includes('DontKnowFinance'), 
            'WorriedSpam': vals.includes('WorriedSpam')
        } : {
            'TooLong': vals.includes('TooLong'), 
            'WorriedSecurity': vals.includes('WorriedSecurity'), 
            'OtherFinance': vals.includes('OtherFinance'), 
            'UnderstandBalloon': vals.includes('UnderstandBalloon'), 
            'Salesperson': vals.includes('Salesperson')
        };
        const data = {...sharedData, ...dataAB};
        if (isNaN(dealerId)){
            console.log('dealerId nan');
            return false;
        }
        dataLayer.push({
            'eventCategory': 'Form Submission',
            'eventAction': 'Toyota Personalised Rate Form - Reasons For Leaving - Submitted',// static value
            'eventLabel': 'Submit - Click', // text copy
            'eventValue': 0,
            'nonInteraction': false,   
            'tprDealerContact': '(not set)'
        });
        // survey.setLeavingModalCookie(null, null, true); not used on tpr 
        const result = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response) => {
            return response.ok;
        })
        .catch((error) => {
            console.log(error);
            return false;
        });
        return result;
    }
}

window.addEventListener('load', function(){
    const surveyForm: Element | null = document.getElementById('survey-form');
    const leavingArr = survey.getLeavingModalCookie();
    const guid = survey.getTprGuid();

    if (!guid && survey.modal && leavingArr.started && !leavingArr.viewed){
        survey.setVersion();
        survey.setLeavingModalCookie(null, true, null);
        document.body.setAttribute('data-modal-open', 'true');
        survey.modal.setAttribute('aria-hidden', 'false');

        const firstInput: HTMLInputElement | null = survey.modal.querySelector('input[type=checkbox]');
        firstInput && firstInput.focus();

        const cancel = survey.modal.querySelector('.button-small-caps');
        cancel && cancel.addEventListener('click', function(e){
            e.preventDefault();
            document.body.setAttribute('data-modal-open', 'false');
            survey.modal?.setAttribute('aria-hidden', 'true');
        });

        const datacheckdiv: Element | null | undefined = surveyForm?.querySelector('.tb-survey-form-field[data-check]');
        if (datacheckdiv){
            const datacheckid: string | null = datacheckdiv.getAttribute('data-check');
            if (datacheckid){
                const datacheckinput: Element | null = document.getElementById(datacheckid);
                datacheckinput && datacheckinput.addEventListener('change', function(){
                    datacheckdiv.setAttribute('aria-hidden', (!this.checked).toString().toLowerCase())
                });
            }
        }

        surveyForm?.addEventListener('submit', function(e){
            e.preventDefault();
            survey.hasClickedSubmit = true;

            if (survey.validateForm(this)){
                survey.submitForm(surveyForm);
            }
        });

        const surveyFields: NodeListOf<HTMLInputElement> | undefined = surveyForm?.querySelectorAll('input[type=checkbox], input[type=text]');
        for (const f of surveyFields as any){ // as any because of ts compiler thing.
            f.addEventListener('change', function(){
                survey.handleChange(surveyForm);
            })
        }
    }
});